import React, { useEffect, useState } from "react";
import { Card, Divider } from "@nextui-org/react";
import { BaseUrl } from "../api";

interface Course {
  code: number;
  name: string;
  numberOfRegistered: number;
}

interface Data {
  total_courses: number;
  total_registered_students: number;
  average_registered_per_course: number;
  most_popular_courses: Course[];
}

const Reports = () => {
  const [dataCourses, setDataCourses] = useState<Data | null>(null);

  useEffect(() => {
    const getData = async () => {
      const response = await fetch(`${BaseUrl}/courses/reports/`, {
        method: "GET",
        credentials: "include",
      });
      const data: Data = await response.json();
      setDataCourses(data);
    };
    getData();
    console.log("dataCourses", dataCourses);
  }, []);

  if (!dataCourses) {
    return <div>Loading...</div>;
  }

  const maxRegistered = Math.max(
    ...dataCourses.most_popular_courses.map(
      (course) => course.numberOfRegistered
    )
  );

  const getBackgroundColor = (numberOfRegistered: number) => {
    if (maxRegistered === 0) return "bg-red-200";
    const percentage = numberOfRegistered / maxRegistered;
    if (percentage >= 0.9) return "bg-green-600";
    if (percentage >= 0.8) return "bg-green-500";
    if (percentage >= 0.7) return "bg-green-400";
    if (percentage >= 0.6) return "bg-green-300";
    if (percentage >= 0.5) return "bg-green-200";
    if (percentage >= 0.4) return "bg-yellow-300";
    if (percentage >= 0.3) return "bg-yellow-200";
    if (percentage >= 0.2) return "bg-orange-300";
    if (percentage >= 0.1) return "bg-orange-200";
    return "bg-red-200";
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-4xl font-bold mb-8">Reports</h1>
      <Card className="bg-white shadow-md rounded-lg p-6 mb-6">
        <span className="text-2xl font-semibold mb-4">Summary</span>
        <p className="text-lg">Total Courses: {dataCourses.total_courses}</p>
        <p className="text-lg">
          Total Registered Students: {dataCourses.total_registered_students}
        </p>
        <p className="text-lg">
          Average Registered per Course:{" "}
          {(dataCourses.average_registered_per_course * 100).toFixed(2) + "%"}
        </p>
      </Card>
      <Card className="bg-[#f6f6f6] shadow-md rounded-lg p-6">
        <span className="text-2xl font-semibold mb-4">
          Most Popular Courses
        </span>
        {dataCourses.most_popular_courses.map((course, index) => (
          <div
            key={course.code}
            className={`py-4 border-b last:border-b-0 ${getBackgroundColor(
              course.numberOfRegistered
            )} px-3 rounded-md mb-2 flex flex-col justify-between`}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-5">
                <div className="text-sm font-semibold">code: {course.code}</div>
                <div className="text-lg font-medium">{course.name}</div>
              </div>
              <div className="text-sm">
                Registered Students: {course.numberOfRegistered}
              </div>
            </div>
            {index < dataCourses.most_popular_courses.length - 1}
          </div>
        ))}
      </Card>
    </div>
  );
};

export default Reports;
